import { mediaMax } from '@/app/styles/breakpoints'
import { Flex, Modal } from 'antd'
import styled from 'styled-components'

export const LogsDataModal = styled(Modal)`
  && {
    ${mediaMax.sm} {
      position: fixed;
      min-width: 100vw;
      min-height: 100vh;
      height: 100vh;
      top: 0;
      left: 0;
      margin: 0;
      display: flex !important;
      flex-direction: column;
      & > div {
        display: flex;
        flex-direction: column;
        height: 100vh;
      }
    }
    .ant-modal-close {
      top: 24px;
      inset-inline-end: 24px;
      ${mediaMax.sm} {
        top: 28px;
        left: 16px;
        right: auto;
      }
    }
    .ant-modal-header {
      margin-bottom: 32px;
      ${mediaMax.sm} {
        height: 88px;
        border-radius: 0;
        margin-bottom: 0;
        box-shadow: 0px 4px 16px 0px rgba(12, 16, 24, 0.12);
        display: flex;
        align-items: center;
        padding: 0 16px 0 64px;
      }
    }

    .ant-modal-content {
      max-height: calc(100vh - 200px);
      display: flex;
      flex-direction: column;
      overflow: hidden;
      box-shadow: none;
      ${mediaMax.md} {
        max-height: calc(100vh - 80px);
      }
      ${mediaMax.sm} {
        max-height: inherit;
        flex: 1;
        padding: 0 0 16px;
        overflow: auto;
      }
      .ant-modal-body {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        ${mediaMax.sm} {
          padding: 24px 12px 0;
        }
        .scrollable {
          height: auto;
          min-height: 328px;
        }
      }
    }
  }
`

export const Content = styled(Flex)`
  && {
    flex: 1;
    min-height: 0;
  }
  > div {
    flex: 1;
    min-height: 0;
    > div {
      flex: 1 1 auto;
      min-height: 0;
    }
  }
`
